import { Testimonial } from '@/app/modules/HomePageV2/types';
import RegistrarF from '@/modules/HomePageV2/assets/RegistrarF.svg';
import RegistrarM from '@/modules/HomePageV2/assets/RegistrarM.svg';
import SeniorMandF from '@/modules/HomePageV2/assets/SeniorMandF.svg';

export const testimonialData: Testimonial[] = [
  {
    text: 'Great way to locum. The staff were very engaging and prepared for every little element of the locum placement. Attention to detail and professionalism was second to none.',
    svgIcon: <SeniorMandF />,
    author: 'Dr Andrew Thelander, ED Consultant',
  },
  {
    text: 'You can choose when you want to work, how long you want to work for and then you can choose when you go back. It’s enabled me to have more time to spend with the family.',
    svgIcon: <RegistrarM />,
    author: 'Dr Kevin Naidoo, General Surgeon',
  },
  {
    text: 'Highly professional, responsive, supportive, knowledgeable.',
    svgIcon: <RegistrarF />,
    author: 'Amy Boudreau, Clinical Director, Psychiatry',
  },
];
